import 'alpine-turbo-drive-adapter';
import 'alpinejs';
import 'livewire-turbolinks';
import 'cleave.js';

import Chart from 'chart.js/auto';
window.Chart = Chart;

import FroalaEditor from 'froala-editor';
import 'froala-editor/js/plugins/lists.min';
window.FroalaEditor = FroalaEditor;
window.FilePond = require('filepond');
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

// Register the plugin
window.FilePond.registerPlugin(FilePondPluginFileValidateType);


/*
|--------------------------------------------------------------------------
| Pusher & Echo
|--------------------------------------------------------------------------
*/
import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');


window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

console.dir(window.Echo)
/*
|--------------------------------------------------------------------------
| Browser notifications
|--------------------------------------------------------------------------
*/
import notification from './browser-notifications';
const userId = document.head.querySelector('meta[name="user-id"]');

if (userId) {
    notification.unregisterBrowserWhenUserIsDifferent(userId.content)
    notification.registerBrowser(userId.content)
} else {
    notification.client.stop().catch(console.error);
}


/*
|--------------------------------------------------------------------------
| Turbolinks
|--------------------------------------------------------------------------
*/
import Turbolinks from 'turbolinks';
Turbolinks.start();


/*
|--------------------------------------------------------------------------
| Datepicker
|--------------------------------------------------------------------------
*/
window.Pikaday = require("pikaday");

/*
|--------------------------------------------------------------------------
| Sortable
|--------------------------------------------------------------------------
*/
window.Sortable = require('sortablejs').default
